// Plain-English explanations of the SEO fields. Pharmacy staff filling these in are not
// marketers: each one says where the value shows up, so it is clear why it is worth setting.

export const SEO_TITLE_TOOLTIP =
  'Shown as the clickable headline in Google search results and browser tabs.';

export const SEO_DESCRIPTION_TOOLTIP =
  'The summary shown under your title in Google search results. It helps convince people to click.';

export const SEO_SOCIAL_TITLE_TOOLTIP =
  'Headline shown when this page is shared on social media. Leave blank to use the Title above.';

export const SEO_SOCIAL_DESCRIPTION_TOOLTIP =
  'Blurb shown when this page is shared on social media. Leave blank to use the Description above.';

export const SEO_SOCIAL_IMAGE_TOOLTIP =
  'Image shown when this page is shared on social media. Recommended: 1200 x 630px.';
